import { useInfiniteQuery } from '@tanstack/react-query';

import { useDebounce } from 'hooks/useDebounce';
import { indexTaggableUsers, TaggableUserResource } from 'services/api/taggableUsers';

export default function useTaggableUsersInfiniteQuery(
  resource: TaggableUserResource | undefined,
  search?: string | undefined,
  delay?: number | undefined
) {
  const queryKeyValues = ['taggableUsers', { ...resource, search }];
  const debouncedQueryKeyValues = useDebounce(queryKeyValues, delay);
  const queryKey = !!delay && delay > 0 ? debouncedQueryKeyValues : queryKeyValues;
  return useInfiniteQuery({
    queryKey,
    enabled: !!resource,
    queryFn: ({ pageParam, signal }) =>
      indexTaggableUsers({ ...(resource as TaggableUserResource), page: pageParam, pageSize: 10, search }, signal),
    initialPageParam: 1,
    getNextPageParam: (lastPage, _pages, lastPageParam) => {
      return lastPage.meta.totalPages > lastPageParam ? lastPageParam + 1 : undefined;
    },
  });
}
